import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Modal from '../Modal';
import {reenableEmployee} from '../../actions/ClientActions';

@connect(
    state => ({
        isReenablingEmployee: state.modal.isReenablingEmployee,
        hasError: state.modal.hasError
    }),
    dispatch => bindActionCreators({reenableEmployee}, dispatch)
)
export default class ConfirmReenableEmployeeModal extends React.Component {
    handleReenable() {
        this.props.reenableEmployee(this.props.client.id, this.props.user.employeeId);
    }
    render() {
        var actionButton = this.props.isReenablingEmployee ?
            (<button className="btn btn-warning disabled">Reenabling...</button>) :
            (<button className="btn btn-warning" onClick={this.handleReenable.bind(this)}>Reenable</button>);
        return (
            <Modal actionButton={actionButton} className="modal-warning" title={"Confirm you would like to reenable employee"}>
                <p>Are you sure you would like to reenable <strong>{this.props.user.name}</strong>?</p>
                {this.props.hasError && <p className='text-danger'>Error reenabling employee!<br/>Please contact a member of the engineering team.</p>}
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/ConfirmReenableEmployeeModal.js